// TODO: Write tests for this file

import {
  FederatedModulesDocsConfig,
  FederatedModulesDocsAppEntry,
  FederatedModulesDocsPageUsageBlock,
  getDocsPathnameOfComponent,
  getDocsRoute,
  getDocsAppRoute,
  getDocsPageRoute,
  getDocsAppPageRoute,
  useGetDocsRoute,
  useGetDocsAppRoute,
  useGetDocsPageRoute,
  useGetDocsAppPageRoute,
} from "./helpers";

// Export types and helpers here that are meant to be exported from the root of the package.

export type {
  FederatedModulesDocsConfig,
  FederatedModulesDocsAppEntry,
  FederatedModulesDocsPageUsageBlock,
};

export const federatedModulesDocsHelpers = {
  getDocsPathnameOfComponent,
  getDocsRoute,
  getDocsAppRoute,
  getDocsPageRoute,
  getDocsAppPageRoute,
  useGetDocsRoute,
  useGetDocsAppRoute,
  useGetDocsPageRoute,
  useGetDocsAppPageRoute,
};
